import React from 'react';
import { DashboardListHoverContent } from './DashboardListHoverContent';
import { QuickstartHoverContent } from './QuickstartHoverContent';
import { TasksHoverContent } from './TasksHoverContent';
import { SpotlightsHoverContent } from './SpotlightsHoverContent';
import { SettingsHoverContent } from './SettingsHoverContent';

/**
 * Central config for mini sidebar hover content.
 * Keys match hoverContentKey on items in sidebar-config.
 * Import this map where the sidebar is rendered (e.g. MiniSidebar) instead of defining it inline.
 */
export const HOVER_CONTENT_MAP: Record<string, React.ReactNode> = {
  dashboards: <DashboardListHoverContent />,
  quickstart: <QuickstartHoverContent />,
  task: <TasksHoverContent />,
  spotlights: <SpotlightsHoverContent />,
  settings: <SettingsHoverContent />,
};
